import { render } from "./InstanceStatusBadge.vue?vue&type=template&id=5322fb72"
import script from "./InstanceStatusBadge.vue?vue&type=script&lang=js"
export * from "./InstanceStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__